import styled from 'styled-components'

export const DropDownContainer = styled('div')`
    height: 36px;
    margin: 0.5rem 0;
    width: 109px;
`

export const DropDownHeader = styled('div')`
    display: flex;
    width: 100%;
    position: relative;
    cursor: pointer;
    justify-content: space-between;
    font-size: 14px;
    align-items: center;
    flex-shrink: 0;
    background: ${properties => properties.theme.variables.colorBackground};
    border: 1px solid rgba(221, 221, 221, 0.5);
    filter: none;
    padding: 8px;
    border-radius: 0.5rem;
    box-shadow: none;
    transform: none;
    opacity: 1;
    font-family: ${properties => properties.theme.variables.fontFamily.text};
    font-weight: 600;
    color: ${properties => properties.theme.variables.colorText};
    margin-botton: 10px;
    &:focus {
        border-color: ${properties => properties.theme.variables.colorPrimary};
        /* box-shadow: ${properties => properties.theme.variables.boxShadow}; */
        color: ${properties => properties.theme.variables.colorText};
        background: ${properties => properties.theme.variables.colorBackground};
        box-shadow: 0 0 0 0.25rem rgb(0 214 50 / 50%);
    }
    &:active {
        border-color: ${properties => properties.theme.variables.colorPrimary};
    }
    &:active:focus {
        /* box-shadow: ${properties => properties.theme.variables.boxShadow}; */
        box-shadow: 0 0 0 0.25rem rgb(0 214 50 / 50%);
    }
    &:hover {
        border: 1px solid rgba(255, 255, 255, 1);
    }
    .control-down-icon {
        color: ${properties => properties.theme.variables.colorText};
        height: 1rem;
        width: 1rem;
    }
`

export const DropDownListContainer = styled('div')`
    position: absolute;
    margin-top: 0.5rem;
    z-index: 1;
`

export const DropDownList = styled('ul')`
    width: 109px;
    background: ${properties => properties.theme.variables.colorBackground};
    border: 1px solid rgba(255, 255, 255, 0.5);
    padding: 0.2rem;
    max-height: 200px;
    overflow-y: scroll;
    border-radius: 0.5rem;
    &:first-child {
        padding-top: 0.5em;
    }
`

export const ListItem = styled('li')`
    list-style: none;
    cursor: pointer;
    color: ${properties => properties.theme.variables.colorText};
    font-family: ${properties => properties.theme.variables.fontFamily.text};
    font-size: 14px;
    font-weight: 600;
    padding: 2px 8px;
    margin-bottom: 0.5em;
`
